import React from 'react';
import { Button } from 'react-admin';
import { l } from '../IdentityShow';
import NoEncryptionIcon from '@material-ui/icons/NoEncryption';
import { useTranslate } from 'react-admin';

interface Props {
  onClick?: () => void;
  [x: string]: any;
}

const Reset2FAButton = (props: Props) => {
  const { onClick, ...rest } = props;

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  return (
    <Button label={t('reset2FA')} onClick={onClick} {...rest}>
      <NoEncryptionIcon />
    </Button>
  );
};

export default Reset2FAButton;
